var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrelaVazia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5979 6.34043C18.1966 4.49781 20.8034 4.49781 21.4021 6.34043L23.429 12.5785C23.6967 13.4026 24.4647 13.9605 25.3311 13.9605H31.8902C33.8277 13.9605 34.6332 16.4397 33.0658 17.5785L27.7594 21.4339C27.0584 21.9432 26.7651 22.8459 27.0328 23.67L29.0597 29.9081C29.6584 31.7507 27.5494 33.2829 25.982 32.1441L20.6756 28.2888C19.9746 27.7795 19.0254 27.7795 18.3244 28.2888L13.018 32.1441C11.4506 33.2829 9.3416 31.7507 9.9403 29.9081L11.9672 23.67C12.2349 22.8459 11.9416 21.9432 11.2406 21.4339L5.9342 17.5785C4.36677 16.4397 5.17232 13.9605 7.10977 13.9605H13.6689C14.5353 13.9605 15.3033 13.4026 15.571 12.5785L17.5979 6.34043Z",
    fill: "#D3D3D3",
    stroke: "#888888",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrelaVazia);
export default __webpack_public_path__ + "static/media/estrelaVazia.abc6de94cb23605b9772c7049c3c7fb1.svg";
export { ForwardRef as ReactComponent };